// @generated by protoc-gen-es v2.10.0 with parameter "target=ts"
// @generated from file sticker/sticker_requests.proto (package com.gem.bff.contract, syntax proto3)

/* eslint-disable */
import type { Message } from '@bufbuild/protobuf';
import type { GenFile, GenMessage } from '@bufbuild/protobuf/codegenv2';
import { fileDesc, messageDesc } from '@bufbuild/protobuf/codegenv2';

/**
 * Describes the file sticker/sticker_requests.proto.
 */
export const file_sticker_sticker_requests: GenFile =
  /*@__PURE__*/
  fileDesc(
    'Ch5zdGlja2VyL3N0aWNrZXJfcmVxdWVzdHMucHJvdG8SFGNvbS5nZW0uYmZmLmNvbnRyYWN0IhgKFkdldFN0aWNrZXJQYWNrc1JlcXVlc3QiJQojR2V0VXNlckluc3RhbGxlZFN0aWNrZXJQYWNrc1JlcXVlc3QiJwoZR2V0U3RpY2tlclBhY2tCeUlkUmVxdWVzdBIKCgJpZBgBIAEoAyI3Ch5BZGRTdGlja2VyUGFja1RvUHJvZmlsZVJlcXVlc3QSFQoNc3RpY2tlclBhY2tJZBgBIAEoAyI8CiNSZW1vdmVTdGlja2VyUGFja0Zyb21Qcm9maWxlUmVxdWVzdBIVCg1zdGlja2VyUGFja0lkGAEgASgDQhgKFGNvbS5nZW0uYmZmLmNvbnRyYWN0UAFiBnByb3RvMw'
  );

/**
 * @generated from message com.gem.bff.contract.GetStickerPacksRequest
 */
export type GetStickerPacksRequest = Message<'com.gem.bff.contract.GetStickerPacksRequest'> & {};

/**
 * Describes the message com.gem.bff.contract.GetStickerPacksRequest.
 * Use `create(GetStickerPacksRequestSchema)` to create a new message.
 */
export const GetStickerPacksRequestSchema: GenMessage<GetStickerPacksRequest> =
  /*@__PURE__*/
  messageDesc(file_sticker_sticker_requests, 0);

/**
 * @generated from message com.gem.bff.contract.GetUserInstalledStickerPacksRequest
 */
export type GetUserInstalledStickerPacksRequest =
  Message<'com.gem.bff.contract.GetUserInstalledStickerPacksRequest'> & {};

/**
 * Describes the message com.gem.bff.contract.GetUserInstalledStickerPacksRequest.
 * Use `create(GetUserInstalledStickerPacksRequestSchema)` to create a new message.
 */
export const GetUserInstalledStickerPacksRequestSchema: GenMessage<GetUserInstalledStickerPacksRequest> =
  /*@__PURE__*/
  messageDesc(file_sticker_sticker_requests, 1);

/**
 * @generated from message com.gem.bff.contract.GetStickerPackByIdRequest
 */
export type GetStickerPackByIdRequest =
  Message<'com.gem.bff.contract.GetStickerPackByIdRequest'> & {
    /**
     * @generated from field: int64 id = 1;
     */
    id: bigint;
  };

/**
 * Describes the message com.gem.bff.contract.GetStickerPackByIdRequest.
 * Use `create(GetStickerPackByIdRequestSchema)` to create a new message.
 */
export const GetStickerPackByIdRequestSchema: GenMessage<GetStickerPackByIdRequest> =
  /*@__PURE__*/
  messageDesc(file_sticker_sticker_requests, 2);

/**
 * @generated from message com.gem.bff.contract.AddStickerPackToProfileRequest
 */
export type AddStickerPackToProfileRequest =
  Message<'com.gem.bff.contract.AddStickerPackToProfileRequest'> & {
    /**
     * @generated from field: int64 stickerPackId = 1;
     */
    stickerPackId: bigint;
  };

/**
 * Describes the message com.gem.bff.contract.AddStickerPackToProfileRequest.
 * Use `create(AddStickerPackToProfileRequestSchema)` to create a new message.
 */
export const AddStickerPackToProfileRequestSchema: GenMessage<AddStickerPackToProfileRequest> =
  /*@__PURE__*/
  messageDesc(file_sticker_sticker_requests, 3);

/**
 * @generated from message com.gem.bff.contract.RemoveStickerPackFromProfileRequest
 */
export type RemoveStickerPackFromProfileRequest =
  Message<'com.gem.bff.contract.RemoveStickerPackFromProfileRequest'> & {
    /**
     * @generated from field: int64 stickerPackId = 1;
     */
    stickerPackId: bigint;
  };

/**
 * Describes the message com.gem.bff.contract.RemoveStickerPackFromProfileRequest.
 * Use `create(RemoveStickerPackFromProfileRequestSchema)` to create a new message.
 */
export const RemoveStickerPackFromProfileRequestSchema: GenMessage<RemoveStickerPackFromProfileRequest> =
  /*@__PURE__*/
  messageDesc(file_sticker_sticker_requests, 4);
